import { NotificationTypes } from "./types";

/**
 * Maximum number of notifications shown at once. When exceeded, the oldest is
 * evicted (FIFO) before the new one is added.
 */
export const MAX_NOTIFICATIONS = 4;

/**
 * Auto-dismiss duration (ms) per notification type. A value of 0 means the
 * notification is "sticky" — it never auto-dismisses and must be closed manually.
 */
export const DEFAULT_DURATIONS: Record<NotificationTypes, number> = {
  [NotificationTypes.SUCCESS]: 5000,
  [NotificationTypes.INFO]: 5000,
  [NotificationTypes.WARNING]: 8000,
  [NotificationTypes.ERROR]: 0,
};

/**
 * Resolve the effective dismiss duration for a notification, falling back to the
 * per-type default when none was provided.
 */
export const resolveDuration = (
  type: NotificationTypes,
  duration?: number,
): number => {
  if (typeof duration === "number") {
    return duration;
  }
  return (
    DEFAULT_DURATIONS[type] ?? DEFAULT_DURATIONS[NotificationTypes.SUCCESS]
  );
};
